import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import customModal from "../customModal/customModal.vue";
import manageRiskTaskModal from "../ManageRIskTaskModal/ManageRIskTaskModal.vue"
import { type } from "jquery";

export default {
    name: 'ManageRiskRegisterModal',
    components: {
        customModal,
        Multiselect,
        manageRiskTaskModal
    },
    props: {
        riskRegId:{
            type: String,
            default: "",
        },
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            idToken: store.getters.getIdToken,
            headerValues: {},
            studyId: "",
            defaultdate: "",
            riskDetails: {},
            originalRiskDetails: null,
            selectedTask: {},
            showTaskModal: false,
            fileList: [],
            taskId: "",
            roleList: [],
            userList: [],
            selectedemailrecipients: [],
            emailrecipients: [],
            
        };
    },
    async mounted() {
        this.studyId = store.getters.getStudyIs;
        this.defaultdate = localStorage.getItem("dateformat");
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        await this.gerRiskById();
        await this.setRoleList();
        await this.getRoleBasedUserlist();
    },
    methods: {
        filter(date) {
            if (date) {
                return moment(date).format(this.defaultdate)
            }
        },
        formatForDateInput(dateString) {
            if (!dateString) return "";
            const dateObj = new Date(dateString);
            return dateObj.toISOString().split("T")[0]; // YYYY-MM-DD
        },
        closeModal() {
            this.$emit('closeModal');
        },
        async gerRiskById(){
            try{
                var response = await axios.get(`${this.baseurl}/forms/riskregister/getriskbyid?id=${this.riskRegId}`, this.headerValues);
                console.log("Risk data is ", response.data);
                this.originalRiskDetails = JSON.parse(JSON.stringify(response.data));
                this.riskDetails = JSON.parse(JSON.stringify(response.data));

                this.riskDetails.responsibleOwner = this.riskDetails.responsibleOwner == null ? [] :  this.riskDetails.responsibleOwner;
                this.riskDetails.resolvedDate = this.formatForDateInput(this.riskDetails.resolvedDate);
                //this.riskDetails.closedDate = this.formatForDateInput(this.riskDetails.closedDate);
            }
            catch (error) {
                console.log("error getting risk...");
            }
        },
        async updateRisk() {
            try {
                this.riskDetails.closedDate = this.riskDetails.closedDate =="" ? null : this.riskDetails.closedDate;
                this.riskDetails.resolvedDate=  this.riskDetails.resolvedDate =="" ? null : this.riskDetails.resolvedDate;

                var response = await axios.put(`${this.baseurl}/forms/riskregister/updateriskscore`, this.riskDetails, this.headerValues);
                console.log("Risk data is ", response.data);
                alert("Risk saved successfully")
                this.closeModal();
            }
            catch (error) {
                console.log("error getting risk...");
            }
        },
        async updateStatus(status) {
            try {
                var response = await axios.put(`${this.baseurl}/forms/riskregister/updatestatus`,
                    {
                        "id": this.riskDetails.id,
                        "status": status
                    }, this.headerValues);
                console.log("Risk data is ", response.data);
                alert("Risk updated successfully");
                this.closeModal();
            }
            catch (error) {
                console.log("error getting risk...");
            }
        },
        async openModal(task) {
            if (task) {
                // Edit mode
                this.taskId = task.taskID || "0";
            } else {
                // Create mode
                this.taskId = "";
            }

            this.showTaskModal = true;
            // this.selectedTask = task;

        },
        async deletetask(task, id) {
            try {
                const confirmation = confirm(
                    "Are you sure you want to delete this task?"
                );
                if (!confirmation) {
                    return;
                }
                var response = await axios.delete(`${this.baseurl}/forms/riskregister/deletetask?riskRegisterId=${id}&taskId=${task.taskID}`, this.headerValues);
                console.log("Task deleted successfully", response.data);
                alert("Task deleted successfully");
                this.$emit('refreshData');
                this.closeTaskManageModal();
                this.gerRiskById();
            } catch (error) {
                console.error("Error deleting task:", error);
            }
        },
        async closeTaskManageModal() {
            this.showTaskModal = false;
            // this.gerRiskById();
        },

        async setRoleList() {
            const idtoken = store.getters.getIdToken;
             axios
                .get(
                `${this.baseurl}/account-core/roles/rolelist`,
                {
                    headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                }
                ).then((res) => {
                    this.roleList = res.data;
                })
        },
        async onClear(){
            this.riskDetails.roles=[];
            this.userList=[]; 
            this.riskDetails.responsibleOwner = [];
        },
        async onRecipientClear(){
            //  this.userList=[];
             this.riskDetails.responsibleOwner = [];
        },
        async onSelectClosed(){
            await this.getRoleBasedUserlist(); 
        },
        async getRoleBasedUserlist() {
            this.userList=[];
            const idtoken = store.getters.getIdToken;
            if(this.riskDetails.roles && this.riskDetails.roles.length>0){
               const fullroleids = this.riskDetails.roles.join(',');
                axios
                .get(
                `${this.baseurl}/account-core/user/getusersbyrole?roleids=${fullroleids}&&studyid=${store.getters.getStudyIs}`,{
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => {
                    if(Array.isArray(res.data) && res.data.length > 0){
                        this.userList = res.data           
                        this.riskDetails.responsibleOwner = this.riskDetails.responsibleOwner.filter(email =>
                    this.userList.some(user => user.email === email)
                    );
                    }
                    else{
                        this.userList=[]
                        this.riskDetails.responsibleOwner=[]
                    }
                    
                })
                .catch((err) => {
                    console.log(err);
                });
            }
            else{
                this.userList =[];
            }
        },
        async refreshTasks() {
            const res = await axios.get(
                `${this.baseurl}/forms/riskregister/getriskbyid?id=${this.riskRegId}`,
                this.headerValues
            );

            this.riskDetails.taskList = res.data.taskList;
        }
    }
}